import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Users, ArrowRight, Instagram, ExternalLink } from "lucide-react";

// California state outline SVG component
const CaliforniaIcon = ({ className }) => (
  <svg viewBox="0 0 1200 1200" fill="currentColor" className={className}>
    <path d="m 812.71249,1194.3333 c -1.76538,-11.6972 -2.3613,-13.1367 -6.91356,-16.7002 -6.70853,-5.2515 -9.81945,-12.4276 -9.62554,-22.2036 0.47834,-24.1166 -24.35612,-63.8237 -47.40582,-75.7957 -5.92216,-3.076 -13.46757,-8.2967 -16.76757,-11.6017 -5.26281,-5.2708 -16.25804,-13.7758 -30.33487,-23.4647 -5.48818,-3.7774 -9.12956,-2.9119 -10.19666,2.4236 -1.77036,8.8518 -5.61416,9.6952 -16.30616,3.5778 -7.49834,-4.2901 -8.05215,-5.3881 -5.75947,-11.4183 l 1.40285,-3.6898 -4.78712,-9.686 c -7.69073,-15.5612 -9.0444,-16.0251 -32.01768,-10.9727 -12.69542,2.7921 -19.30198,2.6235 -19.37006,-0.4941 -0.0197,-0.9027 -3.91972,-3.3762 -8.66667,-5.4966 -5.55196,-2.4801 -8.63083,-4.6368 -8.63083,-6.0459 0,-4.71749 -7.209,-6.81395 -32.31197,-9.39665 -13.39508,-1.37815 -28.84264,-3.74991 -34.32789,-5.27056 -11.6556,-3.23127 -22.82136,-3.46234 -39.01678,-0.80744 -13.86189,2.27236 -18.59617,1.20349 -21.06458,-4.75582 -2.05647,-4.96474 -7.33255,-9.2016 -11.45859,-9.2016 -3.53711,0 -4.01045,-2.5997 -1.94215,-10.66666 2.78218,-10.85126 2.78732,-11.59348 0.102,-14.68974 -3.31721,-3.82478 -3.34928,-6.8138 -0.116,-10.80681 l 2.53071,-3.12531 -3.86404,-1.6247 c -4.53941,-1.90868 -4.69584,-3.40424 -1.8898,-18.0683 1.32545,-6.92666 1.56667,-11.38566 0.73437,-13.57478 l -1.23942,-3.25992 -6.40127,-0.87064 c -8.90989,-1.21183 -9.88568,-1.56106 -14.33284,-5.12968 l -3.93157,-3.1549 -0.20698,-6.52266 c -0.27721,-8.73658 -6.49652,-19.74622 -18.1764,-32.17658 -4.99773,-5.31888 -9.0868,-10.85745 -9.0868,-12.30793 0,-1.78792 -1.18085,-2.90319 -3.66666,-3.46303 -15.07034,-3.39401 -17.14568,-4.82996 -15.91004,-11.00818 1.01326,-5.06628 -1.89111,-10.40046 -9.19278,-16.88351 -4.65193,-4.1304 -6.1865,-6.53627 -6.80365,-10.66667 -0.94581,-6.32997 -2.5346,-8.66666 -5.89272,-8.66666 -1.35997,0 -3.28764,-1.35 -4.28372,-3 -10.5946,-17.54992 -13.677,-21.42215 -18.84389,-23.67244 -10.2065,-4.44514 -16.73962,-13.79476 -16.74054,-23.95758 -3.8e-4,-4.1402 -1.16901,-10.44389 -2.66666,-14.38429 -4.80288,-12.63649 -1.82626,-20.98847 7.14662,-20.05231 l 3.83347,0.39995 2.36735,-6.02616 2.36736,-6.02617 -2.34662,-11.11902 c -2.82802,-13.40008 -3.33728,-13.80168 -16.16794,-12.75022 l -10.13375,0.83045 -9.27241,-7.78777 c -5.09984,-4.28328 -13.61912,-12.56576 -18.93175,-18.40554 l -9.65932,-10.61774 0.28159,-13.4946 0.28158,-13.4946 -4.26617,-6.20066 -4.26616,-6.20066 0.91111,-17.25835 0.9111,-17.25835 -8.52769,-8.18906 c -4.69024,-4.50399 -10.91561,-9.42942 -13.83415,-10.94542 -2.91854,-1.51598 -7.5187,-4.53416 -10.22258,-6.70705 -5.14279,-4.13285 -7.85516,-4.6358 -16.13764,-2.99231 l -5,0.99214 v -4.3159 c 0,-2.98386 1.00122,-5.10346 3.24408,-6.86769 1.78424,-1.40348 3.43424,-3.88983 3.66666,-5.52523 L 214,508.66667 l 4,0.39124 4,0.39122 -4.28177,-2.82285 c -2.35498,-1.55257 -5.86678,-5.95313 -7.804,-9.77903 -1.9387,-3.82878 -5.22142,-7.93136 -7.3017,-9.12528 l -3.77946,-2.1691 0.52712,-4.16507 0.52712,-4.16507 -12.63438,-13.8071 c -6.9489,-7.59392 -14.07078,-14.7483 -15.8264,-15.89863 -1.75562,-1.15032 -10.75268,-11.12637 -19.99346,-22.16901 l -16.80143,-20.07752 0.87941,-3.63523 c 0.48368,-1.99939 1.39156,-5.02429 2.01752,-6.72204 1.50583,-4.08419 1.45888,-14.55756 -0.0695,-15.50215 -0.66418,-0.41049 -3.12194,-5.99589 -5.46169,-12.41202 l -4.25409,-11.6657 0.94027,-14.66666 c 2.62084,-40.88079 0.7449,-48.6825 -16.11043,-67.00023 l -9.9065,-10.76599 -0.10122,-4.45022 L 102.46425,254 90.04658,242.92957 77.628908,231.85915 76.683841,223.03424 c -0.519786,-4.85369 -1.865588,-10.75525 -2.990669,-13.11457 -3.098824,-6.4983 -1.582003,-11.25146 12.853769,-40.27892 7.195676,-14.46908 13.795849,-28.50596 14.667049,-31.19308 l 1.58401,-4.88566 -2.06567,-4.94384 c -3.116914,-7.45983 -2.589717,-14.07098 2.83864,-35.597125 l 4.95414,-19.645621 -2.34923,-12.254867 C 103.23095,45.758207 101.57225,42.571577 94.045592,37.816433 87.205327,33.494933 86.64422,31.159663 91.150889,25.768967 95.920007,20.064343 96.556556,16.508683 94.00486,9.8271637 92.763119,6.5757107 92.085209,3.0344589 92.498395,1.9577155 L 93.24964,0 h 203.2348 203.2348 l 0.78729,20.333333 c 0.43302,11.183334 1.11919,35.033334 1.52482,53 0.40562,17.966667 1.88961,77.966667 3.29773,133.333337 1.40812,55.36666 2.97423,118.77544 3.48025,140.90837 0.50603,22.13295 1.28094,40.75887 1.72202,41.39093 0.44109,0.63207 16.10198,14.06026 34.80198,29.84042 18.7,15.78014 96.54903,81.60424 172.99784,146.27573 76.44883,64.67151 139.59424,117.58455 140.32316,117.58455 1.25719,0 14.24012,10.82041 84.01234,70.01866 16.5,13.99944 38.4,32.54254 48.66666,41.20688 10.26667,8.66435 30.81667,26.0178 45.66667,38.56322 l 27,22.80985 v 9.61583 9.61581 l 9.9625,8.4182 9.9625,8.41821 2.7498,8.14378 c 1.5124,4.47908 4.2293,9.53368 6.0375,11.23242 2.3693,2.22587 3.2877,4.49548 3.2877,8.12498 v 5.03632 l 11.256,5.57757 c 6.1908,3.06765 12.8887,7.28172 14.8842,9.36459 l 3.6282,3.78702 -2.5509,5.6691 c -3.4488,7.66472 -15.689,19.90692 -24.232,24.236 -6.8694,3.48097 -8.2904,5.19769 -5.6522,6.82822 2.4088,1.48871 1.4037,5.31403 -3.3244,12.65283 -6.8418,10.61954 -7.2288,14.69264 -2.1694,22.83154 3.0109,4.8434 3.8292,7.3121 2.9626,8.9371 -0.6586,1.2349 -1.8671,7.7657 -2.6857,14.513 -1.67,13.7651 -5.0351,22.9062 -10.1917,27.6852 l -3.4754,3.2209 3.6563,11.2271 3.6563,11.2272 -2.2143,6.7698 c -3.9413,12.0498 0.5483,16.0269 11.5909,10.2677 l 3.8051,-1.9846 3.7736,4.0397 c 11.1993,11.9888 7.4825,33.3866 -7.2792,41.9069 -17.0773,9.857 -61.7773,17.411 -197.438,33.3658 -48.68019,5.7252 -72.29669,9.4574 -76.25477,12.0508 -4.08116,2.6741 -4.06756,2.6841 -5.03274,-3.711 z"/>
  </svg>
);

const Home = () => {
  // Load Mirror App script for Instagram widget
  useEffect(() => {
    // Check if script already exists to avoid duplicates
    const existingScript = document.querySelector('script[src="https://cdn.jsdelivr.net/npm/@mirrorapp/iframe-bridge@latest/dist/index.umd.js"]');
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/@mirrorapp/iframe-bridge@latest/dist/index.umd.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const stats = [
    { number: "160+", label: "Lives Saved", icon: Heart },
    { number: "501(c)(3)", label: "Nonprofit Est. 2024", icon: Users },
    { number: "CA", label: "And Beyond", icon: CaliforniaIcon },
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="relative min-h-[70vh] lg:min-h-[60vh] flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.pexels.com/photos/6568941/pexels-photo-6568941.jpeg?auto=compress&cs=tinysrgb&w=1920"
            alt="Rescue dog"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-transparent" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-12">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
                501(c)(3) Nonprofit • Est. 2024
              </span>
              <h1 className="font-['Bebas_Neue'] text-6xl sm:text-7xl lg:text-9xl text-white leading-none mb-6 hero-text-shadow">
                160+
                <span className="block text-[#FFD700]">Lives Saved</span>
              </h1>
              <p className="text-xl text-[#A3A3A3] max-w-xl mb-8 leading-relaxed">
                We fight for the voiceless. A US Navy Veteran founded, woman-run rescue dedicated to saving at-risk animals from high-kill shelters.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/donate"
                  data-testid="hero-donate-button"
                  className="btn-primary inline-flex items-center gap-2"
                >
                  Donate Now
                  <ArrowRight className="w-5 h-5" />
                </Link>
                <Link
                  to="/our-pets"
                  data-testid="hero-adopt-button"
                  className="btn-secondary inline-flex items-center gap-2"
                >
                  View Adoptable Pets
                </Link>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <div className="w-6 h-10 border-2 border-[#4A5320] rounded-full flex justify-center">
            <motion.div
              animate={{ y: [0, 12, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
              className="w-1.5 h-3 bg-[#FFD700] rounded-full mt-2"
            />
          </div>
        </motion.div>
      </section>

      {/* Stats Section */}
      <section className="bg-[#1A1C18] border-y border-[#4A5320]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-4 p-4"
              >
                <div className="w-14 h-14 bg-[#4A5320] flex items-center justify-center flex-shrink-0">
                  <stat.icon className="w-7 h-7 text-[#FFD700]" />
                </div>
                <div>
                  <span className="stat-number text-[#FFD700]">{stat.number}</span>
                  <span className="block text-[#A3A3A3] font-mono text-xs uppercase tracking-widest">
                    {stat.label}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
                Our Story
              </span>
              <h2 className="font-['Bebas_Neue'] text-5xl lg:text-6xl text-white mb-6">
                Why &ldquo;Three Eye Blind&rdquo;?
              </h2>
              <p className="text-[#A3A3A3] text-lg mb-6 leading-relaxed">
                In 2022, our founder rescued three one-eyed kittens from a California shelter. These little warriors—Maverick, Goose, and Iceman (yes, she&apos;s a Top Gun fan)—inspired a movement.
              </p>
              <p className="text-[#A3A3A3] text-lg mb-8 leading-relaxed">
                Today, 3 Eye Blind Animal Rescue fights for dogs and cats facing euthanasia simply because they&apos;ve been in shelters too long. Their crime? Needing more time to find love.
              </p>
              <Link
                to="/about"
                data-testid="about-link"
                className="inline-flex items-center gap-2 text-[#FFD700] font-mono text-sm uppercase tracking-widest hover:gap-4 transition-all"
              >
                Read Our Full Story
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="relative">
                <img
                  src="/three-cats.png"
                  alt="Maverick, Goose, and Iceman - the three one-eyed cats"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 border border-[#FFD700] translate-x-4 translate-y-4 -z-10" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Instagram Feed Section */}
      <section className="py-24 lg:py-32 bg-[#1A1C18]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
              Follow Our Journey
            </span>
            <h2 className="font-['Bebas_Neue'] text-5xl lg:text-6xl text-white mb-4">
              @3eyeblindrescue
            </h2>
            <p className="text-[#A3A3A3] max-w-xl mx-auto">
              Stay connected with our latest rescues, happy tails, and behind-the-scenes moments.
            </p>
          </div>

          {/* Mirror App Instagram Feed Widget */}
          <div className="mb-8">
            <iframe 
              src="https://app.mirror-app.com/feed-instagram/db5c25e0-0185-4d92-8e5a-6ea56cc13a45/preview" 
              style={{ width: '100%', border: 'none', overflow: 'hidden', minHeight: '500px' }}
              scrolling="no"
              title="Instagram Feed"
            />
          </div>

          <div className="text-center mt-8">
            <a
              href="https://www.instagram.com/3eyeblindrescue/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-link"
              className="inline-flex items-center gap-2 btn-secondary"
            >
              <Instagram className="w-5 h-5" />
              Follow on Instagram
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 lg:py-32 relative overflow-hidden">
        <div className="absolute inset-0 bg-[#4A5320]/20" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
              Make A Difference
            </span>
            <h2 className="font-['Bebas_Neue'] text-5xl lg:text-7xl text-white mb-6">
              Every Life Matters
            </h2>
            <p className="text-[#A3A3A3] text-xl max-w-2xl mx-auto mb-10">
              Whether you adopt, foster, volunteer, or donate—you become part of a mission bigger than any one of us. Together, we save lives.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/applications"
                data-testid="cta-adopt-button"
                className="btn-primary inline-flex items-center gap-2"
              >
                Adopt or Foster
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link
                to="/donate"
                data-testid="cta-donate-button"
                className="btn-secondary inline-flex items-center gap-2"
              >
                Support Our Mission
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
